import React, { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../state/hooks';
import { fetchVigilNotifications, dismissNotificationAsync } from '../../state/slices/vigilSlice';
import { useIsSampleCompany, SAMPLE_COMPANY_TOOLTIP } from '../../state/hooks/useIsSampleCompany';
import './VigilDashboardTab.css';

const SEVERITY_ORDER: Record<string, number> = { critical: 0, high: 1, medium: 2, low: 3 };

const VigilDashboardTab: React.FC = () => {
  const dispatch = useAppDispatch();
  const { activeCompanyId } = useAppSelector((state) => state.companies);
  const companyId = activeCompanyId ? parseInt(activeCompanyId.replace('company_', '')) : null;
  const { notifications, loading } = useAppSelector((state) => state.vigil);
  const isSampleCompany = useIsSampleCompany();

  useEffect(() => {
    if (companyId) {
      dispatch(fetchVigilNotifications(companyId));
    }
  }, [companyId, dispatch]);

  const sorted = [...notifications].sort(
    (a, b) => (SEVERITY_ORDER[a.severity] ?? 9) - (SEVERITY_ORDER[b.severity] ?? 9)
  );

  const handleDismiss = (id: number) => {
    dispatch(dismissNotificationAsync(id));
  };

  if (!companyId) {
    return <div className="vigil-empty">Select a company to view Vigil Dashboard.</div>;
  }

  return (
    <div className="vigil-dashboard">
      <h3>Vigil Notifications ({notifications.length})</h3>
      {loading && <div className="vigil-loading">Loading...</div>}
      {sorted.length === 0 && !loading && <p className="vigil-empty">No pending notifications.</p>}
      {sorted.map((n) => (
        <div key={n.id} className={`vigil-card severity-${n.severity}`}>
          <div className="vigil-header">
            <span className={`vigil-severity sev-${n.severity}`}>{n.severity.toUpperCase()}</span>
            <span className="vigil-type">{n.task_type}</span>
            <span className="vigil-time">{new Date(n.created_at).toLocaleString()}</span>
          </div>
          <div className="vigil-title">{n.title}</div>
          {n.summary && <div className="vigil-summary">{n.summary}</div>}
          <button
            className="vigil-dismiss"
            onClick={() => handleDismiss(n.id)}
            disabled={isSampleCompany}
            title={isSampleCompany ? SAMPLE_COMPANY_TOOLTIP : undefined}
          >
            Dismiss
          </button>
        </div>
      ))}
    </div>
  );
};

export default VigilDashboardTab;
